"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorage = void 0;
exports.localStorage = {
    getDebugConfig: () => window.localStorage.getItem("debug"),
};
